import { Component, OnInit } from '@angular/core';
import { ChildrenOutletContexts, NavigationEnd, Router, RouterModule } from '@angular/router';
import { AuthJwtService } from '../../services/auth-jwt.service';
import { Helpers } from '../../helpers/helpers';
import { TrackingService } from '../../services/tracking.service';
import { LogType } from '../../enums/logtype';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { fadeInOutAnimation } from '../../animations';
import { LanguageService } from '../../services/language.service';

@Component({
  templateUrl: './default-layout.component.html',
  animations: [fadeInOutAnimation]
})

export class DefaultLayoutComponent implements OnInit {

  private unsubscribe$ = new Subject<void>();

  isAuthenticated = false;
  isLogin = false;

  constructor(
    private router: Router,
    private authJwtService: AuthJwtService,
    private contexts: ChildrenOutletContexts,
    private trackingService: TrackingService,
    public helper: Helpers,
    private languageService: LanguageService
  ) {

  }

  async ngOnInit() {
    // Esperar a que los idiomas estén cargados
    try {
      await this.languageService.waitForLanguages();
    } catch (error) {
      console.error('Error loading languages:', error);
    }

    const currentRoute = this.router.url;
    if (currentRoute.startsWith('/login')) {
      this.isLogin = true;
    }
    this.isAuthenticated = this.authJwtService.isAuthenticated();
    this.router.events.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe((ev) => {
      if (ev instanceof NavigationEnd) {
        this.trackUser(LogType.Nav);
        this.toggleAdminStyleClass();
      }
    });
    this.toggleAdminStyleClass();
  }

  getAnimationData() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
  };

  trackUser(idLogType) {
    this.trackingService.trackUser({ IdLogType: idLogType, Url: this.router.url }).subscribe();
  }

  toggleAdminStyleClass() {
    let body = document.getElementsByTagName('body')[0];
    if (this.router.url.includes('/admin/')) {
      body.classList.add('admin-layout');
    } else {
      body.classList.remove('admin-layout');
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}

